import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheck, FiX, FiAlertTriangle, FiInfo } = FiIcons;

let toastId = 0;

const toastTypes = {
  success: {
    icon: FiCheck,
    bgColor: 'bg-green-500',
    textColor: 'text-white'
  },
  error: {
    icon: FiX,
    bgColor: 'bg-red-500',
    textColor: 'text-white'
  },
  warning: {
    icon: FiAlertTriangle,
    bgColor: 'bg-yellow-500',
    textColor: 'text-white'
  },
  info: {
    icon: FiInfo,
    bgColor: 'bg-blue-500',
    textColor: 'text-white'
  }
};

export const toast = {
  success: (message) => window.dispatchEvent(new CustomEvent('toast', { detail: { type: 'success', message } })),
  error: (message) => window.dispatchEvent(new CustomEvent('toast', { detail: { type: 'error', message } })),
  warning: (message) => window.dispatchEvent(new CustomEvent('toast', { detail: { type: 'warning', message } })),
  info: (message) => window.dispatchEvent(new CustomEvent('toast', { detail: { type: 'info', message } }))
};

export const Toaster = () => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const handleToast = (event) => {
      const { type, message } = event.detail;
      const id = ++toastId;
      
      setToasts(prev => [...prev, { id, type, message }]);
      
      setTimeout(() => {
        setToasts(prev => prev.filter(toast => toast.id !== id));
      }, 4000);
    };

    window.addEventListener('toast', handleToast);
    return () => window.removeEventListener('toast', handleToast);
  }, []);

  const removeToast = (id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  };

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2">
      <AnimatePresence>
        {toasts.map((toast) => {
          const config = toastTypes[toast.type];
          
          return (
            <motion.div
              key={toast.id}
              initial={{ opacity: 0, x: 300, scale: 0.3 }}
              animate={{ opacity: 1, x: 0, scale: 1 }}
              exit={{ opacity: 0, x: 300, scale: 0.5 }}
              transition={{ duration: 0.2 }}
              className={`flex items-center p-4 rounded-lg shadow-lg max-w-sm ${config.bgColor} ${config.textColor}`}
            >
              <SafeIcon icon={config.icon} className="w-5 h-5 mr-3 flex-shrink-0" />
              <p className="flex-1 text-sm font-medium">{toast.message}</p>
              <button
                onClick={() => removeToast(toast.id)}
                className="ml-3 flex-shrink-0 opacity-70 hover:opacity-100 transition-opacity"
              >
                <SafeIcon icon={FiX} className="w-4 h-4" />
              </button>
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
};